import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#63CB51" }}>Brief</span>
            </h2>
            <p>
              beach bandits is a one-stop solution, beach rental app that offers
              a wide variety of beach equipment and accessories for a fun day at
              the beach.
            </p>
            <h2 style={{ color: "#717783" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                service -{" "}
                <span style={{ color: "#63CB51" }}> UI & UX Design</span>
              </div>
              <div className="mission_box">
                objective -{" "}
                <span style={{ color: "#63CB51" }}> On-Demand Rental App</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#63CB51" }}> Mobile Application</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
